import { render } from "./PromoItem.vue?vue&type=template&id=2f8b02a7"
import script from "./PromoItem.vue?vue&type=script&lang=js"
export * from "./PromoItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__